module.exports = {
	siteUrl: `https://www.botwise.io`, // Site domain. Do not include a trailing slash!

	postsPerPage: 12, // Number of posts shown on paginated pages (changes this requires sometimes to delete the cache)

	siteTitleMeta: `BOTWISE - szybki dostęp do rozproszonej wiedzy w organizacji`, // This allows an alternative site title for meta data for pages.
	siteDescriptionMeta: `Przyspiesz dostęp do istniejącej wiedzy organizacji, poprzez jedno okno inteligentnego bota. Podnieś efektywność działów Obsługi Klienta i HR`, // This allows an alternative site description for meta data for pages.

	shareImageWidth: 1000, // Change to the width of your default share image
	shareImageHeight: 523, // Change to the height of your default share image

	shortTitle: `BOTWISE`, // Used for App manifest e.g. Mobile Home Screen
	siteIcon: `favicon.png`, // Logo in /static dir used for SEO, RSS, and App manifest
	backgroundColor: `#ffffff`, // Used for Offline Manifest
	themeColor: `#20bda3`, // Used for Offline Manifest
};
